// @ts-check
import overviewIcon from '../assets/icons/analytics/dashboards/overview.svg'
import monthIcon from '../assets/icons/analytics/dashboards/month.svg'
import dayIcon from '../assets/icons/analytics/dashboards/day.svg'
import gridIcon from '../assets/icons/analytics/dashboards/grid.svg'
import perceptionIcon from '../assets/icons/analytics/dashboards/perception.svg'
import timelineIcon from '../assets/icons/analytics/dashboards/timeline.svg'
import overviewCalendarIcon from '../assets/icons/analytics/dashboards/overviewCalendar.svg'
import weatherIndexIcon from '../assets/icons/analytics/dashboards/weatherIndex.svg'
import gaugeIcon from '../assets/icons/analytics/dashboards/gaugeIcon.svg'
import tableIcon from '../assets/icons/analytics/dashboards/tableIcon.svg'
import uptimeIcon from '../assets/icons/analytics/dashboards/uptimeIcon.svg'
import aerationIcon from '../assets/icons/event-types/aeration.svg'
import bio_treatmentIcon from '../assets/icons/event-types/bio_treatment.svg'
import diseaseIcon from '../assets/icons/event-types/disease.svg'
import divotingIcon from '../assets/icons/event-types/divoting.svg'
import fertilizingIcon from '../assets/icons/event-types/fertilizing.svg'
import groomingIcon from '../assets/icons/event-types/grooming.svg'
import heatingIcon from '../assets/icons/event-types/heating.svg'
import irrigationIcon from '../assets/icons/event-types/irrigation.svg'
import matchIcon from '../assets/icons/event-types/match.svg'
import mowingIcon from '../assets/icons/event-types/mowing.svg'
import seedingIcon from '../assets/icons/event-types/seeding.svg'
import trainingIcon from '../assets/icons/event-types/training.svg'
import nutrient_analysisIcon from '../assets/icons/tests/nutrient_analysis.svg'
import waterIcon from '../assets/icons/weather/humidity.svg'
import temperatureIcon from '../assets/icons/weather/temperature.svg'
import lightIcon from '../assets/icons/weather/brightness.svg'
import windIcon from '../assets/icons/weather/wind.svg'
import linemarkingIcon from '../assets/icons/event-types/linemarking.svg'
import topdressingIcon from '../assets/icons/event-types/topdressing.svg'

import { colors } from 'shared-ui'
import { rgba } from 'polished'
import { dashInfoMap } from './tableauStaticText'

const ids = {
    playerOverview: 'playerOverview',
    playerOverviewBaseball: 'playerOverviewBaseball',
    playerOverviewRugby: 'playerOverviewRugby',
    playerOverviewGaelic: 'playerOverviewGaelic',
    playerMonth: 'playerMonth',
    playerMonthBaseball: 'playerMonthBaseball',
    playerMonthRugby: 'playerMonthRugby',
    playerMonthGaelic: 'playerMonthGaelic',
    playerDay: 'playerDay',
    playerDayBaseball: 'playerDayBaseball',
    playerDayRugby: 'playerDayRugby',
    playerDayGaelic: 'playerDayGaelic',
    playerZone: 'playerZone',
    playerZoneBaseballClay: 'playerZoneBaseballClay',
    playerZoneBaseballGrass: 'playerZoneBaseballGrass',
    playerZoneRugby: 'playerZoneRugby',
    playerZoneGaelic: 'playerZoneGaelic',
    playerPerception: 'playerPerception',
    playerPerformanceIndex: 'playerPerformanceIndex',
    playerInjuryIndex: 'playerInjuryIndex',
    playerBootIndex: 'playerBootIndex',
    pitchOverview: 'pitchOverview',
    pitchMonth: 'pitchMonth',
    pitchDay: 'pitchDay',
    pitchZone: 'pitchZone',
    pitchZoneRugby: 'pitchZoneRugby',
    pitchZoneGaelic: 'pitchZoneGaelic',
    pitchSoil: 'pitchSoil',
    calendarOverview: 'calendarOverview',
    calendarTimeline: 'calendarTimeline',
    calendarGreenkeepingStats: 'calendarGreenkeepingStats',
    calendarMatch: 'calendarMatch',
    calendarMatchBaseball: 'calendarMatchBaseball',
    calendarMatchRugby: 'calendarMatchRugby',
    calendarMatchGaelic: 'calendarMatchGaelic',
    calendarTraining: 'calendarTraining',
    calendarTrainingBaseball: 'calendarTrainingBaseball',
    calendarTrainingRugby: 'calendarTrainingRugby',
    calendarTrainingGaelic: 'calendarTrainingGaelic',
    calendarAeration: 'calendarAeration',
    calendarBiotreatment: 'calendarBiotreatment',
    calendarDisease: 'calendarDisease',
    calendarDiseaseBaseball: 'calendarDiseaseBaseball',
    calendarDiseaseRugby: 'calendarDiseaseRugby',
    calendarDiseaseGaelic: 'calendarDiseaseGaelic',
    calendarDivoting: 'calendarDivoting',
    calendarDivotingBaseball: 'calendarDivotingBaseball',
    calendarDivotingRugby: 'calendarDivotingRugby',
    calendarDivotingGaelic: 'calendarDivotingGaelic',
    calendarFertilising: 'calendarFertilising',
    calendarGrooming: 'calendarGrooming',
    calendarHeating: 'calendarHeating',
    calendarIrrigation: 'calendarIrrigation',
    calendarIrrigationBaseball: 'calendarIrrigationBaseball',
    calendarIrrigationRugby: 'calendarIrrigationRugby',
    calendarIrrigationGaelic: 'calendarIrrigationGaelic',
    calendarLinemarking: 'calendarLinemarking',
    calendarMowing: 'calendarMowing',
    calendarSeeding: 'calendarSeeding',
    calendarTopdressing: 'calendarTopdressing',
    weatherIndex: 'weatherIndex',
    weatherTemperature: 'weatherTemperature',
    weatherLight: 'weatherLight',
    weatherWater: 'weatherWater',
    weatherVentilation: 'weatherVentilation',
    weatherUptime: 'weatherUptime'
}

const translationKeys = {
    [ids.playerOverview]: 'overview',
    [ids.playerMonth]: 'month',
    [ids.playerDay]: 'day',
    [ids.playerZone]: 'zone',
    [ids.playerZoneBaseballClay]: 'zoneClay',
    [ids.playerZoneBaseballGrass]: 'zoneGrass',
    [ids.playerPerception]: 'perception',
    [ids.playerPerformanceIndex]: 'performanceIndex',
    [ids.playerInjuryIndex]: 'injuryIndex',
    [ids.playerBootIndex]: 'bootIndex',
    [ids.pitchOverview]: 'overview',
    [ids.pitchMonth]: 'month',
    [ids.pitchDay]: 'day',
    [ids.pitchZone]: 'zone',
    [ids.pitchSoil]: 'soilNutrient',
    [ids.calendarOverview]: 'overview',
    [ids.calendarTimeline]: 'timeline',
    [ids.calendarGreenkeepingStats]: 'greenkeepingStats',
    [ids.calendarMatch]: 'match',
    [ids.calendarTraining]: 'training',
    [ids.calendarAeration]: 'aeration',
    [ids.calendarBiotreatment]: 'bioTreatment',
    [ids.calendarDisease]: 'disease',
    [ids.calendarDivoting]: 'divoting',
    [ids.calendarFertilising]: 'fertilising',
    [ids.calendarGrooming]: 'grooming',
    [ids.calendarHeating]: 'heating',
    [ids.calendarIrrigation]: 'irrigation',
    [ids.calendarLinemarking]: 'lineMarking',
    [ids.calendarMowing]: 'mowing',
    [ids.calendarSeeding]: 'seeding',
    [ids.calendarTopdressing]: 'topDressing',
    [ids.weatherIndex]: 'weatherIndex',
    [ids.weatherTemperature]: 'temperature',
    [ids.weatherLight]: 'light',
    [ids.weatherWater]: 'waterPresence',
    [ids.weatherVentilation]: 'ventilation',
    [ids.weatherUptime]: 'uptime'
}

// sports, will filter which dashboards the user sees based on his sports
export const sports = {
    football: 'football',
    gridiron: 'gridiron',
    rugby: 'rugby',
    cricket: 'cricket',
    baseball: 'baseball',
    polo: 'polo',
    'gaelic-foot': 'gaelic-foot'
}

// grouped content, to make navigating dashboard selectors easier
const collections = {
    player: 'Player',
    pitch: 'Pitch',
    artificial: 'Artificial',
    equine: 'Equine',
    calendar: 'Calendar',
    weather: 'Weather'
}

export function getCollectionColor(coll) {
    switch (coll) {
        case collections.player: return rgba(colors.main2, 0.55)
        case collections.pitch: return rgba(colors.main1, 0.55)
        case collections.weather: return rgba(colors.super, 0.55)
        default: return rgba(colors.white, 0.55)
    }
}

export function getSportLabel(sport) {
    return sports[sport]
}

/**
 * @typedef {Object} HardcodedFilter
 * @property {string} name - The name of the filter.
 * @property {string} collection - The collection the filter belongs to.
 * @property {string} [sport] - The sport the filter belongs to.
 * @property {string[]} values - The values of the the (as string).
 */

/**
 * @type {HardcodedFilter[]}
 */

const hardcodedFilters = [
    {
        name: 'Parameter Name',
        collection: collections.player,
        sport: sports.football,
        values: [
            "Hardness",
            "ER - Energy Restitution",
            "FR - Shock Absorption",
            "VD - Surface Deformation",
            "Spring Rate",
            "Rotational Traction",
            "Stud Force",
            "Stud Depth",
            "Torque at 10°",
            "Rotational Stiffness",
        ]
    },
    {
        name: 'Parameter Name',
        collection: collections.pitch,
        sport: sports.football,
        values: [
            "Moisture",
            "Electrical Conductivity",
            "Soil Temperature",
            "Density",
            "Density Scanner",
            "pH",
            "Infiltration",
            "Root Depth",
            "Grass Height",
            "Thatch Depth",
        ]
    },
    {
        name: 'Parameter Name',
        collection: collections.player,
        sport: sports.baseball,
        values: [
            "Hardness baseball clay",
            "Hardness baseball grass",
            "Energy Restitution baseball clay",
            "Energy Restitution baseball grass",
            "Shock Absorption baseball clay",
            "Shock Absorption baseball grass",
            "Surface Deformation baseball clay",
            "Surface Deformation baseball grass",
            "Spring Rate baseball clay",
            "Spring Rate baseball grass",
            "Rotational Traction baseball clay",
            "Rotational Traction baseball grass",
            "Stud Depth baseball clay",
            "Stud Depth baseball grass",
            "Rotational Stiffness - Clay",
            "Rotational Stiffness - Grass",
            "Torque at 10° baseball clay",
            "Torque at 10° baseball grass",
        ]
    },
    {
        name: 'Parameter Name',
        collection: collections.player,
        sport: sports.rugby,
        values: [
            "Hardness Rugby",
            "ER - Energy Restitution Rugby",
            "FR - Shock Absorption Rugby",
            "VD - Surface Deformation Rugby",
            "Spring Rate Rugby",
            "Rotational Traction Rugby",
            "Stud Depth Rugby",
            "Torque at 10° Rugby",
            "Rotational Stiffness Rugby",
        ]
    },
    {
        name: 'Parameter Name',
        collection: collections.player,
        sport: sports['gaelic-foot'],
        values: [
            "Hardness Gaelic",
            "ER - Energy Restitution Gaelic",
            "FR - Shock Absorption Gaelic",
            "VD - Surface Deformation Gaelic",
            "Spring Rate Gaelic",
            "Rotational Traction Gaelic",
            "Stud Depth Gaelic",
            "Torque at 10° Gaelic",
            "Rotational Stiffness Gaelic",
        ]
    },
    {
        name: 'Event Type',
        collection: collections.calendar,
        values: [
            "Activity",
            "Aeration",
            "BioTreatment",
            "Disease",
            "Divoting",
            "Fertilising",
            "Grooming",
            "Heating",
            "Injury",
            "Irrigation",
            "LineMarking",
            "Match",
            "Mowing",
            "Note",
            "PlayerPerception",
            "Seeding",
            "TopDressing",
            "Training",
        ]
    },
]

/**
 * @typedef {Object} Filter
 * @property {string} name - The name of the filter.
 * @property {number} [flexOrder] - The flex order of the filter (optional). 
 * @property {'hardcode' | 'pitches' | 'dates'} dataSource - The data source of the filter.
 * @property {string} [addDefaultOption] - The default option (value will be null) of the filter (optional).
 * @property {string} [selectedOption] - The default selected option of the filter (optional).
 * @property {string[]} [values] - The list of hardcoded option values (optional).
 * @property {string[]} [sheetNames] - The list of tableau sheets this filter only applies to (optional).
 */

/**
 * @typedef {Object} LinkedFilter
 * @property {string} name - The name of the parameter.
 */

/**
 * @typedef {Object} LinkedParameter
 * @property {string} name - The name of the filter.
 */

/**
 * @typedef {Object} RenderingRule
 * @property {string} valEquals - The name of the parameter.
 * @property {number[]} hideElementIndices - The list of indices of the controls in the shared container to hide. 
 */

/**
 * @typedef {Object} Parameter
 * @property {string} name - The name of the parameter.
 * @property {number} [flexOrder] - The flex order of the parameter (optional). 
 * @property {string} [label] - The display name of the parameter (optional). 
 * @property {RenderingRule[]} [conditionalRenderingRules] - Rules to hide other controls in the shared container based on this parameter's state. 
 */

/**
 * @typedef {Object} Dashboard
 * @property {string} id - The ID of the dashboard.
 * @property {string} label - The label of the dashboard.
 * @property {string} collection - The collection associated with the dashboard, which they are grouped by in the picker.
 * @property {string[]} sports - The sports associated with the dashboard, used to filter out irrelevant sports to the user.
 * @property {string} urlPart - The URL part of the dashboard that comes after the /views/ part of the base url of where the embed is hosted.
 * @property {string} icon - The icon of the dashboard shown in the dashboard picker. (typed string due to svgs being imported as strings in this project)
 * @property {string} toolTipTranslationKey - The tooltip of the dashboard, shown in the dashboard picker's info header.
 * @property {Object} ui - The UI configuration of the dashboard.
 * @property {number} ui.baseHeight - The base height of the dashboard in px.
 * @property {boolean} ui.resize - Whether the vertical resize button is shown.
 * @property {boolean} ui.download - Whether the download button is shown.
 * @property {boolean} ui.dispose - Whether the dashboard can be disposed.
 * @property {boolean} ui.reset - Whether the dashboard can be reset.
 * @property {boolean} [ui.hideBorder] - Whether to style the dashboard with a border.
 * @property {Element} ui.infoHtml - The HTML information of the dashboard.
 * @property {Object} behavior - The behavior configuration of the dashboard.
 * @property {boolean} behavior.globalDateFilter - Whether the dashboard has a global date filter.
 * @property {boolean} behavior.globalPitchFilter - Whether the dashboard has a global pitch filter.
 * @property {string[]} [behavior.globalPitchFilterSheetNames] - The sheetnames the global filter only applies to.
 * @property {boolean} [behavior.useDateLines] - Whether the dashboard uses datelines to synchronise graph domains.
 * @property {Parameter[]} [behavior.parameters] - The parameters of the dashboard.
 * @property {Filter[]} [behavior.filters] - The filters of the dashboard.
 * @property {Object|undefined} viz - The visualization configuration of the dashboard.
 * 
 * @property {SecondaryDashboard} [secondaryDashboard] - The configuration of the secondary dashboard.
 */

/**
 * @typedef {Object} SecondaryDashboard
 * @property {string | null} label - The label of the secondary dashboard.
 * @property {string} urlPart - The URL part of the secondary dashboard.
 * @property {boolean} isHidden - Whether the secondary dashboard is hidden from view per default.
 * @property {Object} ui - The UI configuration of the secondary dashboard.
 * @property {number} ui.baseHeight - The base height of the secondary dashboard.
 * @property {boolean} ui.resize - Whether the secondary dashboard can be resized.
 * @property {boolean} ui.download - Whether the secondary dashboard can be downloaded.
 * @property {boolean} [ui.reset] - Whether the secondary dashboard can be reset.
 * @property {boolean} [ui.hide] - Whether the title and ui of the secondary secondary dashboard is hidden.
 * @property {Object} behavior - The behavior configuration of the secondary dashboard.
 * @property {boolean} behavior.globalDateFilter - Whether the secondary dashboard has a global date filter.
 * @property {boolean} behavior.globalPitchFilter - Whether the secondary dashboard has a global pitch filter.
 * @property {string[]} [behavior.globalPitchFilterSheetNames] - The sheetnames the global filter only applies to.
 * @property {boolean} [behavior.useDateLines] - Whether the secondary dashboard uses datelines to synchronise graph domains.
 * @property {Parameter[]} [behavior.parameters] - The parameters of the secondary dashboard.
 * @property {Filter[]} [behavior.filters] - The filters of the secondary dashboard.
 * @property {LinkedFilter[]} [behavior.linkedFilters] - The filters of the primary dashboard which are shared by the secondary dashboard.
 * @property {LinkedParameter[]} [behavior.linkedParameters] - The parameters of the primary dashboard which are shared by the secondary dashboard.
 * @property {Object|undefined} viz - The visualization configuration of the secondary dashboard.
 */

/**
 * Array of dashboards.
 * @type {Dashboard[]}
 */


// edit
const dashboards = [
    //PLAYER
    {
        id: ids.playerOverview,
        label: translationKeys[ids.playerOverview],
        collection: collections.player,
        sports: [sports.football],
        urlPart: 'PlayerRLS2/PlayerOverviewv2',
        icon: overviewIcon,
        toolTipTranslationKey: 'ttPlayerOverview',
        ui: {
            baseHeight: 480,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerOverview],
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'impactStabilityAll',
                    flexOrder: 1,
                },
                {
                    name: 'scoreMeasurement',
                    flexOrder: 2,
                },
            ]
        },
        viz: undefined
    },
    {
        id: ids.playerOverviewBaseball,
        label: translationKeys[ids.playerOverview],
        collection: collections.player,
        sports: [sports.baseball],
        urlPart: 'PlayerBASEBALL/PlayerOverviewv2',
        icon: overviewIcon,
        toolTipTranslationKey: 'ttPlayerOverview',
        ui: {
            baseHeight: 480,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerOverview],
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'clayGrass',
                    flexOrder: 1,
                },
                {
                    name: 'impactStabilityAll',
                    flexOrder: 2,
                },
                {
                    name: 'scoreMeasurement',
                    flexOrder: 3,
                },
            ]
        },
        viz: undefined
    },
    {
        id: ids.playerOverviewRugby,
        label: translationKeys[ids.playerOverview],
        collection: collections.player,
        sports: [sports.rugby],
        urlPart: 'PlayerRUGBY/PlayerOverviewv2',
        icon: overviewIcon,
        toolTipTranslationKey: 'ttPlayerOverview',
        ui: {
            baseHeight: 480,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerOverview],
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'impactStabilityAll',
                    flexOrder: 1,
                },
                {
                    name: 'scoreMeasurement',
                    flexOrder: 2,
                },
            ]
        },
        viz: undefined
    },
    {
        id: ids.playerOverviewGaelic,
        label: translationKeys[ids.playerOverview],
        collection: collections.player,
        sports: [sports['gaelic-foot']],
        urlPart: 'PlayerGAELIC/PlayerOverviewv2',
        icon: overviewIcon,
        toolTipTranslationKey: 'ttPlayerOverview',
        ui: {
            baseHeight: 480,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerOverview],
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'impactStabilityAll',
                    flexOrder: 1,
                },
                {
                    name: 'scoreMeasurement',
                    flexOrder: 2,
                },
            ]
        },
        viz: undefined
    },
    {
        id: ids.playerMonth,
        label: translationKeys[ids.playerMonth],
        collection: collections.player,
        sports: [sports.football],
        urlPart: 'PlayerRLS2/Monthv2',
        icon: monthIcon,
        toolTipTranslationKey: 'ttPlayerMonth',
        ui: {
            baseHeight: 880,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerMonth]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'groupDatesGroupPitches',
                    flexOrder: 1
                },
            ],
        },
        viz: undefined
    },
    {
        id: ids.playerMonthBaseball,
        label: translationKeys[ids.playerMonth],
        collection: collections.player,
        sports: [sports.baseball],
        urlPart: 'PlayerBASEBALL/Monthv2',
        icon: monthIcon,
        toolTipTranslationKey: 'ttPlayerMonth',
        ui: {
            baseHeight: 880,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerMonth]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'groupDatesGroupPitches',
                    flexOrder: 1
                },
            ],
        },
        viz: undefined
    },
    {
        id: ids.playerMonthRugby,
        label: translationKeys[ids.playerMonth],
        collection: collections.player,
        sports: [sports.rugby],
        urlPart: 'PlayerRUGBY/Monthv2',
        icon: monthIcon,
        toolTipTranslationKey: 'ttPlayerMonth',
        ui: {
            baseHeight: 880,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerMonth]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'groupDatesGroupPitches',
                    flexOrder: 1
                },
            ],
        },
        viz: undefined
    },
    {
        id: ids.playerMonthGaelic,
        label: translationKeys[ids.playerMonth],
        collection: collections.player,
        sports: [sports['gaelic-foot']],
        urlPart: 'PlayerGAELIC/Monthv2',
        icon: monthIcon,
        toolTipTranslationKey: 'ttPlayerMonth',
        ui: {
            baseHeight: 880,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerMonth]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'groupDatesGroupPitches',
                    flexOrder: 1
                },
            ],
        },
        viz: undefined
    },
    {
        id: ids.playerDay,
        label: translationKeys[ids.playerDay],
        collection: collections.player,
        sports: [sports.football],
        urlPart: 'PlayerRLS2/PlayerDayEmbed',
        icon: dayIcon,
        toolTipTranslationKey: 'ttPlayerDay',
        ui: {
            baseHeight: 684,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerDay]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'separateOverlay',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Parameter Name',
                    dataSource: 'hardcode',
                    values: hardcodedFilters
                        .filter(f => f.collection === collections.player && f.sport === sports.football)
                        .find(f => f.name === 'Parameter Name')
                        ?.values || [],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined
    },
    {
        id: ids.playerDayBaseball,
        label: translationKeys[ids.playerDay],
        collection: collections.player,
        sports: [sports.baseball],
        urlPart: 'PlayerBASEBALL/PlayerDayEmbed',
        icon: dayIcon,
        toolTipTranslationKey: 'ttPlayerDay',
        ui: {
            baseHeight: 684,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerDay]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'separateOverlay',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Parameter Name',
                    dataSource: 'hardcode',
                    values: hardcodedFilters
                        .filter(f => f.collection === collections.player && f.sport === sports.baseball)
                        .find(f => f.name === 'Parameter Name')
                        ?.values || [],

                    flexOrder: 2
                }
            ]
        },
        viz: undefined
    },
    {
        id: ids.playerDayRugby,
        label: translationKeys[ids.playerDay],
        collection: collections.player,
        sports: [sports.rugby],
        urlPart: 'PlayerRUGBY/PlayerDayEmbed',
        icon: dayIcon,
        toolTipTranslationKey: 'ttPlayerDay',
        ui: {
            baseHeight: 684,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerDay]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'separateOverlay',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Parameter Name',
                    dataSource: 'hardcode',
                    values: hardcodedFilters
                        .filter(f => f.collection === collections.player && f.sport === sports.rugby)
                        .find(f => f.name === 'Parameter Name')
                        ?.values || [],

                    flexOrder: 2
                }
            ]
        },
        viz: undefined
    },
    {
        id: ids.playerDayGaelic,
        label: translationKeys[ids.playerDay],
        collection: collections.player,
        sports: [sports['gaelic-foot']],
        urlPart: 'PlayerGAELIC/PlayerDayEmbed',
        icon: dayIcon,
        toolTipTranslationKey: 'ttPlayerDay',
        ui: {
            baseHeight: 684,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerDay]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'separateOverlay',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Parameter Name',
                    dataSource: 'hardcode',
                    values: hardcodedFilters
                        .filter(f => f.collection === collections.player && f.sport === sports['gaelic-foot'])
                        .find(f => f.name === 'Parameter Name')
                        ?.values || [],

                    flexOrder: 2
                }
            ]
        },
        viz: undefined
    },
    {
        id: ids.playerZone,
        label: translationKeys[ids.playerZone],
        collection: collections.player,
        sports: [sports.football],
        urlPart: 'PlayerRLS2/PlayerZoneEmbed1',
        icon: gridIcon,
        toolTipTranslationKey: 'ttPlayerZone',
        ui: {
            baseHeight: 360,
            resize: false,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerZone],
            hideBorder: true,
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: false,
            filters: [
                {
                    name: 'Parameter Name',
                    dataSource: 'hardcode',
                    values: hardcodedFilters
                        .filter(f => f.collection === collections.player && f.sport === sports.football)
                        .find(f => f.name === 'Parameter Name')
                        ?.values || [],

                    flexOrder: 1
                },
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: 'compare',
            urlPart: 'PlayerRLS2/PlayerZoneEmbed1',
            isHidden: true,
            ui: {
                baseHeight: 360,
                resize: false,
                download: true,
                reset: true,
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                filters: [
                    {
                        name: 'Parameter Name',
                        dataSource: 'hardcode',
                        values: hardcodedFilters
                            .filter(f => f.collection === collections.player && f.sport === sports.football)
                            .find(f => f.name === 'Parameter Name')
                            ?.values || [],

                        flexOrder: 1
                    },
                    {
                        name: 'Pitch Id',
                        dataSource: 'pitches',
                        addDefaultOption: 'Select a pitch',
                        flexOrder: 2
                    },
                    {
                        name: 'Datetime',
                        dataSource: 'dates',
                        flexOrder: 3
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.playerZoneBaseballClay,   //Clay
        label: translationKeys[ids.playerZoneBaseballClay],
        collection: collections.player,
        sports: [sports.baseball],
        urlPart: 'PlayerBASEBALL/PlayerZoneEmbed1',
        icon: gridIcon,
        toolTipTranslationKey: 'ttPlayerZone',
        ui: {
            baseHeight: 360,
            resize: false,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerZone],
            hideBorder: true,
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: false,
            filters: [
                {
                    name: 'Parameter Name',
                    dataSource: 'hardcode',
                    values: hardcodedFilters
                        .filter(f => f.collection === collections.player && f.sport === sports.baseball)
                        .find(f => f.name === 'Parameter Name')
                        ?.values
                        .filter(v => v.toLowerCase().includes('clay')) || []
                    ,
                    flexOrder: 1
                },
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: 'Compare',
            urlPart: 'PlayerBASEBALL/PlayerZoneEmbed1',
            isHidden: true,
            ui: {
                baseHeight: 360,
                resize: false,
                download: true,
                reset: true,
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                filters: [
                    {
                        name: 'Parameter Name',
                        dataSource: 'hardcode',
                        values: hardcodedFilters
                            .filter(f => f.collection === collections.player && f.sport === sports.baseball)
                            .find(f => f.name === 'Parameter Name')
                            ?.values
                            .filter(v => v.toLowerCase().includes('clay')) || []
                        ,
                        flexOrder: 1
                    },
                    {
                        name: 'Pitch Id',
                        dataSource: 'pitches',
                        addDefaultOption: 'Select a pitch',
                        flexOrder: 2
                    },
                    {
                        name: 'Datetime',
                        dataSource: 'dates',
                        flexOrder: 3
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.playerZoneBaseballGrass,  //GRASS
        label: translationKeys[ids.playerZoneBaseballGrass],
        collection: collections.player,
        sports: [sports.baseball],
        urlPart: 'PlayerBASEBALL/PlayerZoneEmbedGrass',
        icon: gridIcon,
        toolTipTranslationKey: 'ttPlayerZone',
        ui: {
            baseHeight: 360,
            resize: false,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerZone],
            hideBorder: true,
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: false,
            filters: [
                {
                    name: 'Parameter Name',
                    dataSource: 'hardcode',
                    values: hardcodedFilters
                        .filter(f => f.collection === collections.player && f.sport === sports.baseball)
                        .find(f => f.name === 'Parameter Name')
                        ?.values
                        .filter(v => v.toLowerCase().includes('grass')) || []
                    ,
                    flexOrder: 1
                },
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: 'Compare',
            urlPart: 'PlayerBASEBALL/PlayerZoneEmbedGrass',
            isHidden: true,
            ui: {
                baseHeight: 360,
                resize: false,
                download: true,
                reset: true,
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                filters: [
                    {
                        name: 'Parameter Name',
                        dataSource: 'hardcode',
                        values: hardcodedFilters
                            .filter(f => f.collection === collections.player && f.sport === sports.baseball)
                            .find(f => f.name === 'Parameter Name')
                            ?.values
                            .filter(v => v.toLowerCase().includes('grass')) || []
                        ,
                        flexOrder: 1
                    },
                    {
                        name: 'Pitch Id',
                        dataSource: 'pitches',
                        addDefaultOption: 'Select a pitch',
                        flexOrder: 2
                    },
                    {
                        name: 'Datetime',
                        dataSource: 'dates',
                        flexOrder: 3
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.playerZoneRugby,
        label: translationKeys[ids.playerZone],
        collection: collections.player,
        sports: [sports.rugby],
        urlPart: 'PlayerRUGBY/PlayerZoneEmbed1',
        icon: gridIcon,
        toolTipTranslationKey: 'ttPlayerZone',
        ui: {
            baseHeight: 360,
            resize: false,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerZone],
            hideBorder: true,
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: false,
            filters: [
                {
                    name: 'Parameter Name',
                    dataSource: 'hardcode',
                    values: hardcodedFilters
                        .filter(f => f.collection === collections.player && f.sport === sports.rugby)
                        .find(f => f.name === 'Parameter Name')
                        ?.values || [],

                    flexOrder: 1
                },
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: 'Compare',
            urlPart: 'PlayerRUGBY/PlayerZoneEmbed1',
            isHidden: true,
            ui: {
                baseHeight: 360,
                resize: false,
                download: true,
                reset: true,
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                filters: [
                    {
                        name: 'Parameter Name',
                        dataSource: 'hardcode',
                        values: hardcodedFilters
                            .filter(f => f.collection === collections.player && f.sport === sports.rugby)
                            .find(f => f.name === 'Parameter Name')
                            ?.values || [],

                        flexOrder: 1
                    },
                    {
                        name: 'Pitch Id',
                        dataSource: 'pitches',
                        addDefaultOption: 'Select a pitch',
                        flexOrder: 2
                    },
                    {
                        name: 'Datetime',
                        dataSource: 'dates',
                        flexOrder: 3
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.playerZoneGaelic,
        label: translationKeys[ids.playerZone],
        collection: collections.player,
        sports: [sports['gaelic-foot']],
        urlPart: 'PlayerGAELIC/PlayerZoneEmbed1',
        icon: gridIcon,
        toolTipTranslationKey: 'ttPlayerZone',
        ui: {
            baseHeight: 360,
            resize: false,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerZone],
            hideBorder: true,
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: false,
            filters: [
                {
                    name: 'Parameter Name',
                    dataSource: 'hardcode',
                    values: hardcodedFilters
                        .filter(f => f.collection === collections.player && f.sport === sports['gaelic-foot'])
                        .find(f => f.name === 'Parameter Name')
                        ?.values || [],

                    flexOrder: 1
                },
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: 'Compare',
            urlPart: 'PlayerGAELIC/PlayerZoneEmbed1',
            isHidden: true,
            ui: {
                baseHeight: 360,
                resize: false,
                download: true,
                reset: true,
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                filters: [
                    {
                        name: 'Parameter Name',
                        dataSource: 'hardcode',
                        values: hardcodedFilters
                            .filter(f => f.collection === collections.player && f.sport === sports['gaelic-foot'])
                            .find(f => f.name === 'Parameter Name')
                            ?.values || [],

                        flexOrder: 1
                    },
                    {
                        name: 'Pitch Id',
                        dataSource: 'pitches',
                        addDefaultOption: 'Select a pitch',
                        flexOrder: 2
                    },
                    {
                        name: 'Datetime',
                        dataSource: 'dates',
                        flexOrder: 3
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.playerPerception,
        label: translationKeys[ids.playerPerception],
        collection: collections.player,
        sports: [...Object.values(sports)],
        urlPart: 'PlayerRLS2/Perceptionembed',
        icon: perceptionIcon,
        toolTipTranslationKey: 'ttPlayerPerception',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerPerception]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'totalBreakdown',
                },
            ]
        },
        viz: undefined
    },
    {
        id: ids.playerPerformanceIndex,
        label: translationKeys[ids.playerPerformanceIndex],
        collection: collections.player,
        sports: [sports.football],
        urlPart: 'PlayerRLS2/PlayerIndexEmbed',
        icon: gaugeIcon,
        toolTipTranslationKey: 'ttPlayerIndex',
        ui: {
            baseHeight: 480,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerPerformanceIndex]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'firmnessEnergyStability',
                },
            ]
        },
        viz: undefined
    },
    {
        id: ids.playerBootIndex,
        label: translationKeys[ids.playerBootIndex],
        collection: collections.player,
        sports: [sports.football],
        urlPart: 'PlayerRLS2/BootIndexEmbed',
        icon: gaugeIcon,
        toolTipTranslationKey: 'ttPlayerBootIndex',
        ui: {
            baseHeight: 580,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerBootIndex]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
        },
        viz: undefined
    },
    {
        id: ids.playerInjuryIndex,
        label: translationKeys[ids.playerInjuryIndex],
        collection: collections.player,
        sports: [sports.football],
        urlPart: 'PlayerRLS2/InjuryIndexEmbed',
        icon: gaugeIcon,
        toolTipTranslationKey: 'ttPlayerInjuryIndex',
        ui: {
            baseHeight: 480,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.playerInjuryIndex]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
        },
        viz: undefined
    },
    //PITCH
    {
        id: ids.pitchOverview,
        label: translationKeys[ids.pitchOverview],
        collection: collections.pitch,
        sports: [sports.football, sports.rugby, sports['gaelic-foot']],
        urlPart: 'PitchRLS2/PitchOverviewembed',
        icon: overviewIcon,
        toolTipTranslationKey: 'ttPitchOverview',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.pitchOverview]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'scoreMeasurement',
                },
            ]
        },
        viz: undefined
    },
    {
        id: ids.pitchMonth,
        label: translationKeys[ids.pitchMonth],
        collection: collections.pitch,
        sports: [sports.football, sports.rugby, sports['gaelic-foot']],
        urlPart: 'PitchRLS2/PitchMonthembed',
        icon: monthIcon,
        toolTipTranslationKey: 'ttPitchMonth',
        ui: {
            baseHeight: 1100,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.pitchMonth]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
        },
        viz: undefined
    },
    {
        id: ids.pitchDay,
        label: translationKeys[ids.pitchDay],
        collection: collections.pitch,
        sports: [sports.football, sports.rugby, sports['gaelic-foot']],
        urlPart: 'PitchRLS2/PitchDayEmbed',
        icon: dayIcon,
        toolTipTranslationKey: 'ttPitchDay',
        ui: {
            baseHeight: 684,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.pitchDay]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'separateOverlay',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Parameter Name',
                    dataSource: 'hardcode',
                    values: hardcodedFilters
                        .filter(f => f.collection === collections.pitch && f.sport === sports.football)
                        .find(f => f.name === 'Parameter Name')
                        ?.values || [],

                    flexOrder: 2
                },
            ]
        },
        viz: undefined
    },
    {
        id: ids.pitchZone,
        label: translationKeys[ids.pitchZone],
        collection: collections.pitch,
        sports: [sports.football],
        urlPart: 'PitchRLS2/PitchZoneEmbed18',
        icon: gridIcon,
        toolTipTranslationKey: 'ttPitchZone',
        ui: {
            baseHeight: 360,
            resize: false,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.pitchZone],
            hideBorder: true,
        },
        behavior: {
            globalDateFilter: true, // can mutate
            globalPitchFilter: false,
            filters: [
                {
                    name: 'Parameter Name',
                    dataSource: 'hardcode',
                    values: hardcodedFilters
                        .filter(f => f.collection === collections.pitch && f.sport === sports.football)
                        .find(f => f.name === 'Parameter Name')
                        ?.values || [],

                    flexOrder: 1
                },
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    flexOrder: 2
                },
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: 'compare',
            urlPart: 'PitchRLS2/PitchZoneEmbed18',
            isHidden: true,
            ui: {
                baseHeight: 360,
                resize: false,
                download: true,
                reset: true,
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                filters: [
                    {
                        name: 'Parameter Name',
                        dataSource: 'hardcode',
                        values: hardcodedFilters
                            .filter(f => f.collection === collections.pitch && f.sport === sports.football)
                            .find(f => f.name === 'Parameter Name')
                            ?.values || [],

                        flexOrder: 1
                    },
                    {
                        name: 'Pitch Id',
                        dataSource: 'pitches',
                        addDefaultOption: 'Select a pitch',
                        flexOrder: 2
                    },
                    {
                        name: 'Datetime',
                        dataSource: 'dates',
                        flexOrder: 3
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.pitchZoneRugby,
        label: translationKeys[ids.pitchZone],
        collection: collections.pitch,
        sports: [sports.rugby],
        urlPart: 'PitchRUGBY/PitchZoneEmbed18',
        icon: gridIcon,
        toolTipTranslationKey: 'ttPitchZone',
        ui: {
            baseHeight: 360,
            resize: false,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.pitchZone],
            hideBorder: true,
        },
        behavior: {
            globalDateFilter: true, // can mutate
            globalPitchFilter: false,
            filters: [
                {
                    name: 'Parameter Name',
                    dataSource: 'hardcode',
                    values: hardcodedFilters
                        .filter(f => f.collection === collections.pitch && f.sport === sports.football)
                        .find(f => f.name === 'Parameter Name')
                        ?.values || [],

                    flexOrder: 1
                },
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    flexOrder: 2
                },
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: 'compare',
            urlPart: 'PitchRUGBY/PitchZoneEmbed18',
            isHidden: true,
            ui: {
                baseHeight: 360,
                resize: false,
                download: true,
                reset: true,
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                filters: [
                    {
                        name: 'Parameter Name',
                        dataSource: 'hardcode',
                        values: hardcodedFilters
                            .filter(f => f.collection === collections.pitch && f.sport === sports.football)
                            .find(f => f.name === 'Parameter Name')
                            ?.values || [],

                        flexOrder: 1
                    },
                    {
                        name: 'Pitch Id',
                        dataSource: 'pitches',
                        addDefaultOption: 'Select a pitch',
                        flexOrder: 2
                    },
                    {
                        name: 'Datetime',
                        dataSource: 'dates',
                        flexOrder: 3
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.pitchZoneGaelic,
        label: translationKeys[ids.pitchZone],
        collection: collections.pitch,
        sports: [sports['gaelic-foot']],
        urlPart: 'PitchGAELIC/PitchZoneEmbed18',
        icon: gridIcon,
        toolTipTranslationKey: 'ttPitchZone',
        ui: {
            baseHeight: 360,
            resize: false,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.pitchZone],
            hideBorder: true,
        },
        behavior: {
            globalDateFilter: true, // can mutate
            globalPitchFilter: false,
            filters: [
                {
                    name: 'Parameter Name',
                    dataSource: 'hardcode',
                    values: hardcodedFilters
                        .filter(f => f.collection === collections.pitch && f.sport === sports.football)
                        .find(f => f.name === 'Parameter Name')
                        ?.values || [],

                    flexOrder: 1
                },
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    flexOrder: 2
                },
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: 'compare',
            urlPart: 'PitchGAELIC/PitchZoneEmbed18',
            isHidden: true,
            ui: {
                baseHeight: 360,
                resize: false,
                download: true,
                reset: true,
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                filters: [
                    {
                        name: 'Parameter Name',
                        dataSource: 'hardcode',
                        values: hardcodedFilters
                            .filter(f => f.collection === collections.pitch && f.sport === sports.football)
                            .find(f => f.name === 'Parameter Name')
                            ?.values || [],

                        flexOrder: 1
                    },
                    {
                        name: 'Pitch Id',
                        dataSource: 'pitches',
                        addDefaultOption: 'Select a pitch',
                        flexOrder: 2
                    },
                    {
                        name: 'Datetime',
                        dataSource: 'dates',
                        flexOrder: 3
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.pitchSoil,
        label: translationKeys[ids.pitchSoil],
        collection: collections.pitch,
        sports: [sports.football, sports.rugby, sports['gaelic-foot']],
        urlPart: 'PitchRLS2/Soilnutrient',
        icon: nutrient_analysisIcon,
        toolTipTranslationKey: 'ttPitchSoil',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.pitchSoil]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: false,
            useDateLines: true,
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                }
            ]
        },
        viz: undefined
    },
    //CALENDAR
    {
        id: ids.calendarOverview,
        label: translationKeys[ids.calendarOverview],
        collection: collections.calendar,
        sports: [...Object.values(sports)],
        urlPart: 'CalendarRLS2/OverviewOfEvents',
        icon: overviewCalendarIcon,
        toolTipTranslationKey: 'ttCalendarOverview',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarOverview]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'perEventPerPitchEventTotalsPitchTotals',
                },
            ]
        },
        viz: undefined
    },
    {
        id: ids.calendarTimeline,
        label: translationKeys[ids.calendarTimeline],
        collection: collections.calendar,
        sports: [...Object.values(sports)],
        urlPart: 'CalendarRLS2/Timeline',
        icon: timelineIcon,
        toolTipTranslationKey: 'ttCalendarTimeline',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarTimeline]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["event timeline multipitch"],
            parameters: [
                {
                    name: 'comparePitchesCompareEvents',
                    flexOrder: 1,
                    conditionalRenderingRules: [
                        {
                            valEquals: 'Compare Events',
                            hideElementIndices: [1]
                        },
                        {
                            valEquals: 'Compare Pitches',
                            hideElementIndices: [2]
                        },
                    ]
                },
            ],
            filters: [
                {
                    name: 'Event Type',
                    dataSource: 'hardcode',
                    values: hardcodedFilters
                        .filter(f => f.collection === collections.calendar)
                        .find(f => f.name === 'Event Type')
                        ?.values || [],

                    selectedOption: 'Mowing',
                    sheetNames: ["event timeline multipitch"],
                    flexOrder: 2
                },
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    sheetNames: ["multievent timeline singlepitch"],
                    addDefaultOption: 'Select a pitch',
                    flexOrder: 3
                },
            ]
        },
        viz: undefined
    },
    {
        id: ids.calendarGreenkeepingStats,
        label: translationKeys[ids.calendarGreenkeepingStats],
        collection: collections.calendar,
        sports: [...Object.values(sports)],
        urlPart: 'CalendarRLS2/GroundsStats',
        icon: tableIcon,
        toolTipTranslationKey: 'ttCalendarGreenkeepingStats',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarGreenkeepingStats]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'statsTotalMonthly',
                    flexOrder: 1
                },
            ]
        },
        viz: undefined
    },
    {
        id: ids.calendarMatch,
        label: translationKeys[ids.calendarMatch],
        collection: collections.calendar,
        sports: [sports.football],
        urlPart: 'CalendarRLS2/Matchgraphs',
        icon: matchIcon,
        toolTipTranslationKey: 'ttCalendarMatch',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarMatch]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["match number of events"],
            parameters: [
                {
                    name: 'toggleTeams',
                    label: 'Teams',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["multievent timeline singlepitch (2)"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Matchgrid',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarMatchBaseball,
        label: translationKeys[ids.calendarMatch],
        collection: collections.calendar,
        sports: [sports.baseball],
        urlPart: 'CalendarRLS2/Matchgraphs',
        icon: matchIcon,
        toolTipTranslationKey: 'ttCalendarMatch',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarMatch]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["match number of events"],
            parameters: [
                {
                    name: 'toggleTeams',
                    label: 'Teams',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["multievent timeline singlepitch (2)"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Matchgridbaseball',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarMatchRugby,
        label: translationKeys[ids.calendarMatch],
        collection: collections.calendar,
        sports: [sports.rugby],
        urlPart: 'CalendarRLS2/Matchgraphs',
        icon: matchIcon,
        toolTipTranslationKey: 'ttCalendarMatch',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarMatch]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["match number of events"],
            parameters: [
                {
                    name: 'toggleTeams',
                    label: 'Teams',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["multievent timeline singlepitch (2)"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Matchgridrugby',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarMatchGaelic,
        label: translationKeys[ids.calendarMatch],
        collection: collections.calendar,
        sports: [sports['gaelic-foot']],
        urlPart: 'CalendarRLS2/Matchgraphs',
        icon: matchIcon,
        toolTipTranslationKey: 'ttCalendarMatch',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarMatch]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["match number of events"],
            parameters: [
                {
                    name: 'toggleTeams',
                    label: 'Teams',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["multievent timeline singlepitch (2)"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Matchgridgaelic',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarTraining,
        label: translationKeys[ids.calendarTraining],
        collection: collections.calendar,
        sports: [sports.football],
        urlPart: 'CalendarRLS2/Traininggraphs',
        icon: trainingIcon,
        toolTipTranslationKey: 'ttCalendarTraining',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarTraining]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["training number of events"],
            parameters: [
                {
                    name: 'toggleTeams',
                    label: 'Teams',
                    flexOrder: 1
                },
                {
                    name: 'toggleTrainings',
                    label: 'Trainings',
                    flexOrder: 2
                },
                {
                    name: 'eventsLoggedHoursLogged',
                    flexOrder: 3
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline training"],
                    flexOrder: 4
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Traininggrid',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarTrainingBaseball,
        label: translationKeys[ids.calendarTraining],
        collection: collections.calendar,
        sports: [sports.baseball],
        urlPart: 'CalendarRLS2/Traininggraphs',
        icon: trainingIcon,
        toolTipTranslationKey: 'ttCalendarTraining',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarTraining]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["training number of events"],
            parameters: [
                {
                    name: 'toggleTeams',
                    label: 'Teams',
                    flexOrder: 1
                },
                {
                    name: 'toggleTrainings',
                    label: 'Trainings',
                    flexOrder: 2
                },
                {
                    name: 'eventsLoggedHoursLogged',
                    flexOrder: 3
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline training"],
                    flexOrder: 4
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Traininggridbaseball',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarTrainingRugby,
        label: translationKeys[ids.calendarTraining],
        collection: collections.calendar,
        sports: [sports.rugby],
        urlPart: 'CalendarRLS2/Traininggraphs',
        icon: trainingIcon,
        toolTipTranslationKey: 'ttCalendarTraining',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarTraining]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["training number of events"],
            parameters: [
                {
                    name: 'toggleTeams',
                    label: 'Teams',
                    flexOrder: 1
                },
                {
                    name: 'toggleTrainings',
                    label: 'Trainings',
                    flexOrder: 2
                },
                {
                    name: 'eventsLoggedHoursLogged',
                    flexOrder: 3
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline training"],
                    flexOrder: 4
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Traininggridrugby',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarTrainingGaelic,
        label: translationKeys[ids.calendarTraining],
        collection: collections.calendar,
        sports: [sports['gaelic-foot']],
        urlPart: 'CalendarRLS2/Traininggraphs',
        icon: trainingIcon,
        toolTipTranslationKey: 'ttCalendarTraining',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarTraining]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["training number of events"],
            parameters: [
                {
                    name: 'toggleTeams',
                    label: 'Teams',
                    flexOrder: 1
                },
                {
                    name: 'toggleTrainings',
                    label: 'Trainings',
                    flexOrder: 2
                },
                {
                    name: 'eventsLoggedHoursLogged',
                    flexOrder: 3
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline training"],
                    flexOrder: 4
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Traininggridgaelic',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarAeration,
        label: translationKeys[ids.calendarAeration],
        collection: collections.calendar,
        sports: [...Object.values(sports)],
        urlPart: 'CalendarRLS2/aerationgraphs',
        icon: aerationIcon,
        toolTipTranslationKey: 'ttCalendarAeration',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarAeration]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["aeration number of events"],
            parameters: [
                {
                    name: 'toggleAerationTypes',
                    label: 'Types',
                    flexOrder: 1
                },
                {
                    name: 'toggleAerationHeives',
                    label: 'Heives',
                    flexOrder: 2
                },
                {
                    name: 'toggleAerationSpacings',
                    label: 'Spacings',
                    flexOrder: 3
                },
                {
                    name: 'eventsLoggedHoursLogged',
                    flexOrder: 4
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline aeration"],
                    flexOrder: 5
                }
            ]
        },
        viz: undefined
    },
    {
        id: ids.calendarBiotreatment,
        label: translationKeys[ids.calendarBiotreatment],
        collection: collections.calendar,
        sports: [...Object.values(sports)],
        urlPart: 'CalendarRLS2/biotreatmentgraphs',
        icon: bio_treatmentIcon,
        toolTipTranslationKey: 'ttCalendarBiotreatment',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarBiotreatment]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["biotreatment number of events"],
            parameters: [
                {
                    name: 'toggleBioType',
                    label: 'Types',
                    flexOrder: 1
                },
                {
                    name: 'toggleBioProduct',
                    label: 'Products',
                    flexOrder: 2
                },
                {
                    name: 'eventsLoggedHoursLogged',
                    flexOrder: 3
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline biotreatment"],
                    flexOrder: 4
                }
            ]
        },
        viz: undefined
    },
    {
        id: ids.calendarDisease,
        label: translationKeys[ids.calendarDisease],
        collection: collections.calendar,
        sports: [sports.football],
        urlPart: 'CalendarRLS2/diseasegraphs',
        icon: diseaseIcon,
        toolTipTranslationKey: 'ttCalendarDisease',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarDisease]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["disease number of events"],
            parameters: [
                {
                    name: 'toggleDiseases',
                    label: 'Diseases',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline disease"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Diseasegrid',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarDiseaseBaseball,
        label: translationKeys[ids.calendarDisease],
        collection: collections.calendar,
        sports: [sports.baseball],
        urlPart: 'CalendarRLS2/diseasegraphs',
        icon: diseaseIcon,
        toolTipTranslationKey: 'ttCalendarDisease',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarDisease]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["disease number of events"],
            parameters: [
                {
                    name: 'toggleDiseases',
                    label: 'Diseases',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline disease"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Diseasegridbaseball',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarDiseaseRugby,
        label: translationKeys[ids.calendarDisease],
        collection: collections.calendar,
        sports: [sports.rugby],
        urlPart: 'CalendarRLS2/diseasegraphs',
        icon: diseaseIcon,
        toolTipTranslationKey: 'ttCalendarDisease',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarDisease]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["disease number of events"],
            parameters: [
                {
                    name: 'toggleDiseases',
                    label: 'Diseases',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline disease"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Diseasegridrugby',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarDiseaseGaelic,
        label: translationKeys[ids.calendarDisease],
        collection: collections.calendar,
        sports: [sports['gaelic-foot']],
        urlPart: 'CalendarRLS2/diseasegraphs',
        icon: diseaseIcon,
        toolTipTranslationKey: 'ttCalendarDisease',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarDisease]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["disease number of events"],
            parameters: [
                {
                    name: 'toggleDiseases',
                    label: 'Diseases',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline disease"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Diseasegridgaelic',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarDivoting,
        label: translationKeys[ids.calendarDivoting],
        collection: collections.calendar,
        sports: [sports.football],
        urlPart: 'CalendarRLS2/divotinggraphs',
        icon: divotingIcon,
        toolTipTranslationKey: 'ttCalendarDivoting',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarDivoting]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["divoting number of events"],
            parameters: [
                {
                    name: 'eventsLoggedHoursLogged',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline divoting"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Divotinggrid',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarDivotingBaseball,
        label: translationKeys[ids.calendarDivoting],
        collection: collections.calendar,
        sports: [sports.baseball],
        urlPart: 'CalendarRLS2/divotinggraphs',
        icon: divotingIcon,
        toolTipTranslationKey: 'ttCalendarDivoting',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarDivoting]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["divoting number of events"],
            parameters: [
                {
                    name: 'eventsLoggedHoursLogged',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline divoting"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Divotinggridbaseball',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarDivotingRugby,
        label: translationKeys[ids.calendarDivoting],
        collection: collections.calendar,
        sports: [sports.rugby],
        urlPart: 'CalendarRLS2/divotinggraphs',
        icon: divotingIcon,
        toolTipTranslationKey: 'ttCalendarDivoting',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarDivoting]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["divoting number of events"],
            parameters: [
                {
                    name: 'eventsLoggedHoursLogged',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline divoting"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Divotinggridrugby',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarDivotingGaelic,
        label: translationKeys[ids.calendarDivoting],
        collection: collections.calendar,
        sports: [sports['gaelic-foot']],
        urlPart: 'CalendarRLS2/divotinggraphs',
        icon: divotingIcon,
        toolTipTranslationKey: 'ttCalendarDivoting',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarDivoting]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["divoting number of events"],
            parameters: [
                {
                    name: 'eventsLoggedHoursLogged',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline divoting"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Divotinggridgaelic',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarFertilising,
        label: translationKeys[ids.calendarFertilising],
        collection: collections.calendar,
        sports: [...Object.values(sports)],
        urlPart: 'CalendarRLS2/fertilisinggraphs',
        icon: fertilizingIcon,
        toolTipTranslationKey: 'ttCalendarFertilising',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarFertilising]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["fertilising number of events"],
            parameters: [
                {
                    name: 'toggleFertilisingType',
                    label: 'Types',
                    flexOrder: 1
                },
                {
                    name: 'fertilisingEventsAmount',
                    flexOrder: 2
                },
                {
                    name: 'filterNPK',
                    flexOrder: 3
                },
                {
                    name: 'dailyAccumulated',
                    flexOrder: 4
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: [
                        "fertilising daily",
                        "fertilising accum",
                        "fertilising title"
                    ],
                    flexOrder: 5
                }
            ]
        },
        viz: undefined
    },
    {
        id: ids.calendarGrooming,
        label: translationKeys[ids.calendarGrooming],
        collection: collections.calendar,
        sports: [...Object.values(sports)],
        urlPart: 'CalendarRLS2/groominggraphs',
        icon: groomingIcon,
        toolTipTranslationKey: 'ttCalendarGrooming',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarGrooming]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["grooming number of events"],
            parameters: [
                {
                    name: 'toggleGroomingTypes',
                    label: 'Types',
                    flexOrder: 1
                },
                {
                    name: 'toggleGroomingDirections',
                    label: 'Directions',
                    flexOrder: 2
                },
                {
                    name: 'groomingEventWeight',
                    flexOrder: 3
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline grooming"],
                    flexOrder: 4
                }
            ]
        },
        viz: undefined
    },
    {
        id: ids.calendarHeating,
        label: translationKeys[ids.calendarHeating],
        collection: collections.calendar,
        sports: [...Object.values(sports)],
        urlPart: 'CalendarRLS2/heatinggraphs',
        icon: heatingIcon,
        toolTipTranslationKey: 'ttCalendarHeating',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarHeating]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["heating number of events"],
            parameters: [
                {
                    name: 'toggleHeatingTypes',
                    label: 'Types',
                    flexOrder: 1
                },
                {
                    name: 'toggleHeatingTemps',
                    label: 'Temps',
                    flexOrder: 2
                },
                {
                    name: 'eventsLoggedHoursLogged',
                    flexOrder: 3
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline heating"],
                    flexOrder: 4
                }
            ]
        },
        viz: undefined
    },
    {
        id: ids.calendarIrrigation,
        label: translationKeys[ids.calendarIrrigation],
        collection: collections.calendar,
        sports: [sports.football],
        urlPart: 'CalendarRLS2/irrigationgraphs',
        icon: irrigationIcon,
        toolTipTranslationKey: 'ttCalendarIrrigation',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarIrrigation]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["irrigation number of events"],
            parameters: [
                {
                    name: 'eventsLoggedMillimetersLogged',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline irrigation"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Irrigationgrid',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ],
                linkedParameters: [
                    {
                        name: 'eventsLoggedMillimetersLogged'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarIrrigationBaseball,
        label: translationKeys[ids.calendarIrrigation],
        collection: collections.calendar,
        sports: [sports.baseball],
        urlPart: 'CalendarRLS2/irrigationgraphs',
        icon: irrigationIcon,
        toolTipTranslationKey: 'ttCalendarIrrigation',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarIrrigation]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["irrigation number of events"],
            parameters: [
                {
                    name: 'eventsLoggedMillimetersLogged',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline irrigation"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Irrigationgridbaseball',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ],
                linkedParameters: [
                    {
                        name: 'eventsLoggedMillimetersLogged'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarIrrigationRugby,
        label: translationKeys[ids.calendarIrrigation],
        collection: collections.calendar,
        sports: [sports.rugby],
        urlPart: 'CalendarRLS2/irrigationgraphs',
        icon: irrigationIcon,
        toolTipTranslationKey: 'ttCalendarIrrigation',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarIrrigation]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["irrigation number of events"],
            parameters: [
                {
                    name: 'eventsLoggedMillimetersLogged',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline irrigation"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Irrigationgridrugby',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ],
                linkedParameters: [
                    {
                        name: 'eventsLoggedMillimetersLogged'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarIrrigationGaelic,
        label: translationKeys[ids.calendarIrrigation],
        collection: collections.calendar,
        sports: [sports['gaelic-foot']],
        urlPart: 'CalendarRLS2/irrigationgraphs',
        icon: irrigationIcon,
        toolTipTranslationKey: 'ttCalendarIrrigation',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarIrrigation]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["irrigation number of events"],
            parameters: [
                {
                    name: 'eventsLoggedMillimetersLogged',
                    flexOrder: 1
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline irrigation"],
                    flexOrder: 2
                }
            ]
        },
        viz: undefined,
        secondaryDashboard: {
            label: null,
            urlPart: 'CalendarRLS2/Irrigationgridgaelic',
            isHidden: false,
            ui: {
                baseHeight: 360,
                resize: false,
                download: false,
                hide: true
            },
            behavior: {
                globalDateFilter: true,
                globalPitchFilter: false,
                linkedFilters: [
                    {
                        name: 'Pitch Id'
                    }
                ],
                linkedParameters: [
                    {
                        name: 'eventsLoggedMillimetersLogged'
                    }
                ]
            },
            viz: undefined
        }
    },
    {
        id: ids.calendarLinemarking,
        label: translationKeys[ids.calendarLinemarking],
        collection: collections.calendar,
        sports: [...Object.values(sports)],
        urlPart: 'CalendarRLS2/linemarkinggraphs',
        icon: linemarkingIcon,
        toolTipTranslationKey: 'ttCalendarLinemarking',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarLinemarking]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["linemarking number of events"],
            parameters: [
                {
                    name: 'toggleLinemarkingMethods',
                    label: 'Methods',
                    flexOrder: 1
                },
                {
                    name: 'linemarkingEventVolumeTime',
                    flexOrder: 2
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline linemarking"],
                    flexOrder: 3
                }
            ]
        },
        viz: undefined,
    },
    {
        id: ids.calendarTopdressing,
        label: translationKeys[ids.calendarTopdressing],
        collection: collections.calendar,
        sports: [...Object.values(sports)],
        urlPart: 'CalendarRLS2/topdressinggraphs',
        icon: topdressingIcon,
        toolTipTranslationKey: 'ttCalendarTopdressing',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarTopdressing]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["topdressing number of events"],
            parameters: [
                {
                    name: 'toggleMaterialTypes',
                    label: 'Materials',
                    flexOrder: 1
                },
                {
                    name: 'topdressingEventWeightTime',
                    flexOrder: 2
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline topdressing"],
                    flexOrder: 3
                }
            ]
        },
        viz: undefined,
    },
    {
        id: ids.calendarMowing,
        label: translationKeys[ids.calendarMowing],
        collection: collections.calendar,
        sports: [...Object.values(sports)],
        urlPart: 'CalendarRLS2/mowinggraphs',
        icon: mowingIcon,
        toolTipTranslationKey: 'ttCalendarMowing',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarMowing]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["mowing number of events"],
            parameters: [
                {
                    name: 'toggleMowingMachines',
                    label: 'Machines',
                    flexOrder: 1
                },
                {
                    name: 'toggleMowingDirections',
                    label: 'Directions',
                    flexOrder: 2
                },
                {
                    name: 'toggleMowingTechniques',
                    label: 'Techniques',
                    flexOrder: 3
                },
                {
                    name: 'byEventsVolumeHeight',
                    flexOrder: 4
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline mowing"],
                    flexOrder: 5
                }
            ]
        },
        viz: undefined
    },
    {
        id: ids.calendarSeeding,
        label: translationKeys[ids.calendarSeeding],
        collection: collections.calendar,
        sports: [...Object.values(sports)],
        urlPart: 'CalendarRLS2/seedinggraphs',
        icon: seedingIcon,
        toolTipTranslationKey: 'ttCalendarSeeding',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.calendarSeeding]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            globalPitchFilterSheetNames: ["seeding number of events"],
            parameters: [
                {
                    name: 'toggleSeedingTypes',
                    label: 'Types',
                    flexOrder: 1
                },
                {
                    name: 'seedingEventWeight',
                    flexOrder: 2
                },
            ],
            filters: [
                {
                    name: 'Pitch Id',
                    dataSource: 'pitches',
                    addDefaultOption: 'Select a pitch',
                    sheetNames: ["singlepitch timeline seeding"],
                    flexOrder: 3
                }
            ]
        },
        viz: undefined
    },
    //WEATHER
    {
        id: ids.weatherIndex,
        label: translationKeys[ids.weatherIndex],
        collection: collections.weather,
        sports: [...Object.values(sports)],
        urlPart: 'WeatherRLS2/Indexes',
        icon: weatherIndexIcon,
        toolTipTranslationKey: 'ttWeatherIndex',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.weatherIndex]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'growthToggle',
                    label: 'Growth Potential Index',
                    flexOrder: 1
                },
                {
                    name: 'diseaseToggle',
                    label: 'Disease Risk Index',
                    flexOrder: 2
                },
            ]
        },
        viz: undefined
    },
    {
        id: ids.weatherTemperature,
        label: translationKeys[ids.weatherTemperature],
        collection: collections.weather,
        sports: [...Object.values(sports)],
        urlPart: 'WeatherRLS2/Temperature',
        icon: temperatureIcon,
        toolTipTranslationKey: 'ttWeatherTemperature',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.weatherTemperature]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'temperatureToggle',
                    label: 'Temperature',
                    flexOrder: 1
                },
                {
                    name: 'gddToggle',
                    label: 'Growing Degrees',
                    flexOrder: 2
                },
                {
                    name: 'Tb',
                    label: 'Tb',
                    flexOrder: 3
                }
            ]
        },
        viz: undefined
    },
    {
        id: ids.weatherLight,
        label: translationKeys[ids.weatherLight],
        collection: collections.weather,
        sports: [...Object.values(sports)],
        urlPart: 'WeatherRLS2/Light',
        icon: lightIcon,
        toolTipTranslationKey: 'ttWeatherLight',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.weatherLight]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'dliToggle',
                    label: 'DLI',
                    flexOrder: 1
                },
                {
                    name: 'radiationToggle',
                    label: 'Solar Radiation',
                    flexOrder: 2
                },
                {
                    name: 'uvToggle',
                    label: 'UV Index',
                    flexOrder: 3
                },
            ]
        },
        viz: undefined
    },
    {
        id: ids.weatherWater,
        label: translationKeys[ids.weatherWater],
        collection: collections.weather,
        sports: [...Object.values(sports)],
        urlPart: 'WeatherRLS2/Water',
        icon: waterIcon,
        toolTipTranslationKey: 'ttWeatherWater',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.weatherWater]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'precipToggle',
                    label: 'Precipitation',
                    flexOrder: 1
                },
                {
                    name: 'humidityToggle',
                    label: 'Relative Humidity',
                    flexOrder: 2
                },
            ]
        },
        viz: undefined
    },
    {
        id: ids.weatherVentilation,
        label: translationKeys[ids.weatherVentilation],
        collection: collections.weather,
        sports: [...Object.values(sports)],
        urlPart: 'WeatherRLS2/Ventilation',
        icon: windIcon,
        toolTipTranslationKey: 'ttWeatherVentilation',
        ui: {
            baseHeight: 380,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.weatherVentilation]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
            parameters: [
                {
                    name: 'windToggle',
                    label: 'Wind Speed',
                    flexOrder: 1
                },
                {
                    name: 'pressureToggle',
                    label: 'Pressure',
                    flexOrder: 2
                },
            ]
        },
        viz: undefined
    },
    {
        id: ids.weatherUptime,
        label: translationKeys[ids.weatherUptime],
        collection: collections.weather,
        sports: [...Object.values(sports)],
        urlPart: 'WeatherRLS2/Uptime',
        icon: uptimeIcon,
        toolTipTranslationKey: 'ttWeatherUptime',
        ui: {
            baseHeight: 200,
            resize: true,
            download: true,
            dispose: true,
            reset: true,
            infoHtml: dashInfoMap[ids.weatherUptime]
        },
        behavior: {
            globalDateFilter: true,
            globalPitchFilter: true,
        },
        viz: undefined
    },
]

export default dashboards